import { cx } from '@linaria/core';
import { useRef } from 'react';
import { UploadIcon, GoogleDriveIcon, OneDriveIcon } from '@ui/kit/icons';
import { ModalButton } from '../atom.modal-button.js';
import { LegacyDriveExportButton } from './atom.drive-export-button.js';
import { driveContainer } from './modal.style.js';
import { useGetCloudEntriesQuery } from './query.get-cloud-entries.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { modal, heading, content } from '../shared.modals.style.js';
import { useComponentEntry } from '../../../api.component-entry/query.get.js';

const makeDriveExportModal = config => ({
  theme: "dialog",
  className: modal,
  content: /*#__PURE__*/jsx(Modal, {
    ...config
  })
});
function Modal(props) {
  const {
    data: componentEntryID
  } = useComponentEntry(props.entryKey, {
    select: entry => entry?.envelope.objectID
  });
  const cloudEntries = useGetCloudEntriesQuery(componentEntryID);
  const googleDriveApi = useRef(window.gExport ? {
    ...window.gExport.GoogleApi,
    upload: window.gExport?.googleDrive
  } : undefined);
  const oneDriveApi = useRef(window.gExport ? {
    ...window.gExport.MicrosoftApi,
    upload: window.gExport?.oneDrive
  } : undefined);
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsxs("h1", {
      className: heading,
      children: [/*#__PURE__*/jsx(UploadIcon, {
        height: "20"
      }), " ", /*#__PURE__*/jsx("span", {
        children: "Gem p\xE5 drev"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: cx(content, driveContainer),
      children: [/*#__PURE__*/jsxs(LegacyDriveExportButton, {
        input: props.input,
        componentTitle: props.componentTitle,
        entryKey: props.entryKey,
        type: "googleDrive",
        format: props.format,
        api: googleDriveApi.current,
        cloudEntry: cloudEntries.data?.googleDrive,
        printCss: props.printCss,
        printOrientation: props.printOrientation,
        onAfterExport: props.onAfterExport,
        onAfterHTMLSent: props.onAfterHTMLSent,
        onBeforeExport: props.onBeforeExport,
        children: [/*#__PURE__*/jsx(ModalButton.Icon, {
          children: /*#__PURE__*/jsx(GoogleDriveIcon, {
            height: "26"
          })
        }), /*#__PURE__*/jsx(ModalButton.Label, {
          children: "Google Drev"
        })]
      }), /*#__PURE__*/jsxs(LegacyDriveExportButton, {
        input: props.input,
        componentTitle: props.componentTitle,
        entryKey: props.entryKey,
        type: "oneDrive",
        format: props.format,
        api: oneDriveApi.current,
        cloudEntry: cloudEntries.data?.oneDrive,
        printCss: props.printCss,
        printOrientation: props.printOrientation,
        onAfterExport: props.onAfterExport,
        onAfterHTMLSent: props.onAfterHTMLSent,
        onBeforeExport: props.onBeforeExport,
        children: [/*#__PURE__*/jsx(ModalButton.Icon, {
          children: /*#__PURE__*/jsx(OneDriveIcon, {
            height: "20"
          })
        }), /*#__PURE__*/jsx(ModalButton.Label, {
          children: "OneDrive"
        })]
      })]
    })]
  });
}

export { makeDriveExportModal };
//# sourceMappingURL=modal.js.map
